// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Models
import {
  useFormSubmissionQuestionsData,
} from '@lyon/scoped-models/answer/FormSubmissionQuestions';
import {
  FormSubmissionQuestionItem,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { LyonEmptyState } from '@lyon/components/empty/LyonEmptyState';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonViewAnswerFormQuestionItem } from './LyonViewAnswerFormQuestionItem';

// ANCHOR Styles
import { BLOCK } from './styles';

// ANCHOR Constant
import { LABEL, IMG_ALT } from './constants';

export const LyonViewAnswerFormQuestions = constant(() => {
  const questionSubmissions = useFormSubmissionQuestionsData();

  if (!questionSubmissions) {
    return <Loader />;
  }

  if (questionSubmissions.length === 0) {
    return (
      <Block width="70%" marginTop="64px">
        <LyonEmptyState
          label={LABEL}
          imgAlt={IMG_ALT}
        />
      </Block>
    );
  }

  return (
    <Block overrides={BLOCK}>
      {
        questionSubmissions.map((submission) => (
          <FormSubmissionQuestionItem.Provider
            key={submission.question.id}
            data={submission}
          >
            <LyonViewAnswerFormQuestionItem />
          </FormSubmissionQuestionItem.Provider>
        ))
      }
    </Block>
  );
});
